<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header [hideTitle]="isDesktop" routeId="settings"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <router-outlet></router-outlet>
</ion-content>
